import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import GroupLoader from './_load/GroupLoader'
import EditGroupForm from './EditGroupForm'

const EditGroupModal = props => {
  return (
    <ControlledModal width="36rem" {...props}>
      {/* <PermissionChecker any={['createUserGroup', 'editUserGroup']}> */}
      <ModalHeader />
      <GroupLoader>
        <EditGroupForm />
      </GroupLoader>
      {/* </PermissionChecker> */}
    </ControlledModal>
  )
}

export default EditGroupModal
